import { Head, Link } from "@inertiajs/react"
import Navbar from "@/components/chalky/Navbar"
import Footer from "@/components/chalky/Footer"

interface Column {
  key: string
  label: string
}

interface Row {
  cloud_id: string
  payload: Record<string, unknown>
}

interface RegistryIndexProps {
  type: { key: string; label: string }
  columns: Column[]
  rows: Row[]
  paths: { dashboard: string }
  i18n: {
    count: number
    reference: string
    empty_state: string
    back: string
  }
}

const cell = (value: unknown): string => (value == null ? "" : String(value))

export default function RegistryIndex({ type, columns, rows, paths, i18n }: RegistryIndexProps) {
  return (
    <>
      <Head>
        <title>{`${type.label} — Chalky Chrono Finish`}</title>
      </Head>

      <div className="bg-[#0a0a0f] min-h-screen text-slate-300 flex flex-col">
        <Navbar />

        <main className="flex-1 px-6 pt-32 pb-24">
          <div className="max-w-4xl mx-auto">
            <Link
              href={paths.dashboard}
              className="text-sm text-violet-400 hover:text-violet-300 transition-colors"
            >
              ← {i18n.back}
            </Link>

            <div className="flex items-baseline gap-3 mt-4 mb-8">
              <h1 className="text-3xl font-bold text-white">{type.label}</h1>
              <span className="text-slate-500">{i18n.count}</span>
            </div>

            {rows.length === 0 ? (
              <div className="bg-white/[0.03] border border-white/[0.07] rounded-2xl p-10 text-center">
                <p className="text-slate-400">{i18n.empty_state}</p>
              </div>
            ) : (
              <div className="overflow-x-auto rounded-2xl border border-white/[0.07]">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-white/[0.03] text-left text-slate-400">
                      {columns.map((column) => (
                        <th key={column.key} className="px-4 py-3 font-medium">
                          {column.label}
                        </th>
                      ))}
                      <th className="px-4 py-3 font-medium text-right">{i18n.reference}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row) => (
                      <tr key={row.cloud_id} className="border-t border-white/[0.05]">
                        {columns.map((column) => (
                          <td key={column.key} className="px-4 py-3 text-white">
                            {cell(row.payload[column.key])}
                          </td>
                        ))}
                        <td className="px-4 py-3 text-right font-mono text-xs text-slate-500">
                          {row.cloud_id}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  )
}
